import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Region } from '../models/classes/region';
import { RegionReference } from '../models/classes/region-reference';
import { RegionMetaDataModel } from '../models/classes/region-metadata';
import { PeriodicCacheModel } from '../models/classes/periodic-cache';
import { Customer } from '../models/classes/owner';

@Injectable({
  providedIn: 'root',
})
export class RegionService {
  errorMessage: string;
  ip = environment.ipServer;
  private userUrl = `${this.ip}/api/region`;
  userRef: BehaviorSubject<RegionReference[]>;
  regRef: RegionReference[] = [];
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
    }),
  };

  constructor(private http: HttpClient) {
    this.userRef = new BehaviorSubject<RegionReference[]>([]);
  }

  getRegions(): Observable<Region[]> {
    return this.http.get<Region[]>(this.userUrl).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  addUserToRegion(regionReference: RegionReference): Subscription {
    return this.http
      .post<RegionReference>(this.userUrl, regionReference)
      .subscribe((data) => {});
  }

  getUsers(id: number) {
    const url = `${this.userUrl}/GetReferences/${id}`;
    return this.http.get<RegionReference[]>(url);
  }

  removeUserFromRegion(id: number) {
    const url = `${this.userUrl}/${id}`;
    return this.http.delete(url, this.httpOptions);
  }

  getCustomers(): Observable<Customer[]> {
    const url = `${this.ip}/api/regionmetadata/GetOwnerList`;
    return this.http.get<Customer[]>(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  getRegionMetaData(id: number): Observable<RegionMetaDataModel> {
    const url = `${this.ip}/api/regionmetadata/${id}`;
    return this.http.get<RegionMetaDataModel>(url).pipe(
      tap((data) =>data),
      catchError(this.handleError)
    );
  }

  getAssignedRegions(id: number): Observable<Region[]> {
    const url = `${this.ip}/api/region/GetAssignedUserRegions/${id}`;
    return this.http.get<Region[]>(url);
  }

  addPeriodicTask(cachemodel: PeriodicCacheModel) {
    const url = `${this.ip}/api/periodictask`;
    return this.http.post(url, cachemodel);
  }

  getPeriodicTask(regionName: string) {
    const url = `${this.ip}/api/periodictask/GetRegionTask/${regionName}`;
    return this.http.get<PeriodicCacheModel>(url);
  }
  get usrRef(): Observable<RegionReference[]> {
    return this.userRef.asObservable();
  }
  private handleError(err: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
